import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Form, Row, Col, Button } from "react-bootstrap";
import ParentCompanyDropdown from "features/admin/sharedAdminComponents/ParentCompanyDropdown";
import LocationDropdown from "features/admin/sharedAdminComponents/LocationDropdown";
import PayerDropdown from "features/admin/sharedAdminComponents/PayerDropdown";
import { IsNullOrWhitespace } from "shared/helpers/StringHelpers";
import { IsNullOrEmpty } from "shared/helpers/NullEmptyHelpers";

import { CompressUriString } from "shared/helpers/DataHelpers";
import { useAdminComponentsData } from "../sharedAdminComponents/hooks/useAdminComponentsData";

import { GetObjectPropertyValue } from "shared/helpers/DataHelpers";

import { GetDaysBetweenDates, GetISODate } from "shared/helpers/DateHelpers";

export default function AdminRxLookupForm(props) {
  // Use the consolidated admin components data hook
  const {
    selectedPayers,
    selectedParentCompany,
    selectedLocations,
    allLocations,
    allPayers,
    setSelectedPayers,
    setSelectedParentCompany,
    setSelectedLocations,
  } = useAdminComponentsData();

  const [rxNumber, setRxNumber] = useState("");
  const [dateType, setDateType] = useState("dispense");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [bin, setBin] = useState("");
  const [ndc, setNdc] = useState("");
  //This page deals with a large amount of data, so we need to limit the date range to no more than 30 days
  const maximumDateRange = 31;
  // Helper function to get the same day in the next month
  const getSameDayNextMonth = (date) => {
    if (!date) return null;

    const nextMonth = new Date(date);
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    return nextMonth;
  };

  // Helper function to get the same day in the previous month
  const getSameDayPreviousMonth = (date) => {
    if (!date) return null;

    const previousMonth = new Date(date);
    previousMonth.setMonth(previousMonth.getMonth() - 1);
    return previousMonth;
  };

  function validateForm() {
    let filtersCount = 0;

    //if they selected a parent company, increment filtersCount by 1
    if (!IsNullOrEmpty(selectedParentCompany)) {
      //if a parent company is selected, but there are no locations available for that parent company, return an error message

      //adding this validator, as if a parent company is selected but no locations are available for that parent company, then proc will consider it an empty argument with performance issues
      if (IsNullOrEmpty(allLocations)) {
        return "No locations available for the selected Parent Company.";
      }

      filtersCount++;
    }

    // if they selected a Payer, increment filtersCount by 1
    if (!IsNullOrEmpty(selectedPayers)) {
      filtersCount++;
    }

    //check if they selected an Rx Number,
    if (!IsNullOrWhitespace(rxNumber)) {
      //Rx number must be at least 5 digits, if not return an error message
      if (rxNumber.length < 5) {
        return "Rx Number must be at least 5 digits.";
      }

      // test passed
      // increment filtersCount by 1
      filtersCount++;
    }

    //if they speified a from date or to date, increment filtersCount by 1 if tests on the dates pass
    if (fromDate || toDate) {
      //they specified a date range, do the tests on the dates
      if (fromDate && !toDate) {
        return "A start date is provided, but an end date must also be provided.";
      }

      if (!fromDate && toDate) {
        return "An end date is provided, but a start date must also be provided.";
      }
      if (toDate < fromDate) {
        return "The end date must be after the start date.";
      } // make sure Rx Number is provided

      if (GetDaysBetweenDates(fromDate, toDate) > maximumDateRange) {
        return `The date range must be no more than ${maximumDateRange} days.`;
      }

      // all test passed
      //increment filtersCount by 1
      filtersCount++;
    }

    if (filtersCount < 2) {
      return "The search must specify at least 2 of the following 4 parameters: Parent Company, Rx Number, Payer, Date Range.";
    }

    return null;
  }
  function handleFormSubmit(e) {
    e.preventDefault();

    let errors = validateForm();
    errors ? alert(errors) : submitForm();
  }
  function submitForm() {
    const locationsValue = GetObjectPropertyValue(
      selectedLocations,
      "value",
      ""
    );

    const payersValue = GetObjectPropertyValue(selectedPayers, "value", "");

    props.handleFormSubmit({
      rxNumber: rxNumber,
      // Use all payers if no specific ones are selected

      //calling a compression function after encountering issues with long query strings in URLs
      payers: IsNullOrEmpty(payersValue)
        ? CompressUriString(allPayers)
        : CompressUriString(payersValue),
      // Use all locations if no specific ones are selected
      locations: IsNullOrEmpty(locationsValue) ? allLocations : locationsValue,
      // Use all parent companies if no specific one is selected
      // parentCompany: IsNullOrEmpty(parentCompanyValue)
      //   ? allParentCompanies
      //   : parentCompanyValue,
      dateType: dateType,
      fromDate: fromDate ? GetISODate(fromDate) : "",
      toDate: toDate ? GetISODate(toDate) : "",
      bin: bin ? bin : "",
      ndc: ndc ? ndc : "",
    });
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      <Row className="justify-content-start">
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Parent Company </Form.Label>
          <Form.Control
            as={ParentCompanyDropdown}
            selectedParentCompany={selectedParentCompany}
            setSelectedParentCompany={setSelectedParentCompany}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Location (NCPDP)</Form.Label>{" "}
          <Form.Control
            as={LocationDropdown}
            selectedParentCompany={selectedParentCompany}
            selectedLocations={selectedLocations}
            setSelectedLocations={setSelectedLocations}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Date Type</Form.Label>
          {/* <Form.Select aria-label="Default select example"
            onChange={(e) => {
              setDateType(e.target.value);
            }}>
            <option value="dispense">Dispense Date</option>
            <option value="transaction">Transaction Date</option>
          </Form.Select> */}
          <div key="DateType">
            <Form.Check
              custom="true"
              type="radio"
              id="rxLookupDateType-1"
              name="DateType"
              label="Dispense date"
              value="dispense"
              onChange={(event) => setDateType(event.target.value)}
              defaultChecked
            />
            <Form.Check
              custom="true"
              type="radio"
              id="rxLookupDateType-1"
              name="DateType"
              label="Transaction date"
              value="transaction"
              onChange={(event) => setDateType(event.target.value)}
            />
          </div>
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            name="fromDate"
            as={DatePicker}
            selected={fromDate}
            onChange={(date) => {
              setFromDate(date);

              // Auto-update toDate if it's empty, more than maximumDateRange days away, or fromDate is after toDate
              if (
                date &&
                (!toDate ||
                  GetDaysBetweenDates(date, toDate) > maximumDateRange - 1 ||
                  date > toDate)
              ) {
                setToDate(getSameDayNextMonth(date));
              }
            }}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>End Date</Form.Label>
          <Form.Control
            name="fromDate"
            as={DatePicker}
            selected={toDate}
            onChange={(date) => {
              setToDate(date);

              // Auto-update fromDate if it's empty, more than maximumDateRange days away, or toDate is before fromDate
              if (
                date &&
                (!fromDate ||
                  GetDaysBetweenDates(fromDate, date) > maximumDateRange - 1 ||
                  date < fromDate)
              ) {
                setFromDate(getSameDayPreviousMonth(date));
              }
            }}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Rx Number</Form.Label>
          <Form.Control
            type="text"
            placeholder=""
            onChange={(e) => {
              setRxNumber(e.target.value);
            }}
            value={rxNumber}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Payer</Form.Label>
          <Form.Control
            as={PayerDropdown}
            selectedPayer={selectedPayers}
            setSelectedPayer={setSelectedPayers}
          />
        </Col>

        <Col md="auto" className="d-flex flex-column">
          <Form.Label>BIN</Form.Label>
          <Form.Control
            type="text"
            placeholder=""
            onChange={(e) => {
              setBin(e.target.value);
            }}
            value={bin}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>NDC</Form.Label>
          <Form.Control
            type="text"
            placeholder=""
            onChange={(e) => {
              setNdc(e.target.value);
            }}
            value={ndc}
          />
        </Col>
      </Row>

      <Row>
        <Col md="auto" className="d-flex flex-column">
          <Button className="inline-show-result-button" size="sm" type="submit">
            Show Results
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
